import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { TeamsService } from 'app/API';
import { useState } from 'react';

type TProps = {
  teamId: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteTeamModal = ({ teamId, onCancel, onSuccess }: TProps) => {
  const { updateMe } = useAuthContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { call } = useAPI();

  const deleteHandler = async () => {
    setIsSubmitting(true);

    await call(TeamsService.remove({ organizationRoleId: teamId }));
    updateMe();
    onSuccess();
    setIsSubmitting(false);
  };

  return (
    <ModalWrapper width="380px">
      <ModalTitle>Confirm</ModalTitle>
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <div className="text-center">
        Are you sure you want to delete this team? <br />
        Associated invites will also be deleted.
      </div>
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={deleteHandler} disabled={isSubmitting} style={{ width: '130px' }}>
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
